// extracted by css-extract-rspack-plugin
export default {"TableContainer":"x0CfI","Table":"YaoEF","HeaderCell":"KzFMi","BodyRow":"zQ2Gz","BodyCell":"Wydzz","LimitInputWrapper":"_JTZ9","InputUnitSection":"unw_9"};